<template>
	<div class="contained-example-container">
		<div
			id="div-with-loading"
			class="vs-con-loading__container text-center text-danger"
		>
			<div class="con-vs-loading vs-loading-background-undefined vs-loading-color-undefined">
				<div
					class="vs-loading default"
					style="transform: scale(0.6);"
				>
					<div class="effect-1 effects"></div>
					<div class="effect-2 effects"></div>
					<div class="effect-3 effects"></div>
					<img src="">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "bTableBusyCustom",
};
</script>
